/**
 * @mui/x-date-pickers-pro v7.23.6
 *
 * @license MUI X Commercial
 * This source code is licensed under the commercial license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  LicenseInfo: true
};
exports.LicenseInfo = void 0;
var _xLicense = require("@mui/x-license");
var _xDatePickers = require("@mui/x-date-pickers");
Object.keys(_xDatePickers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _xDatePickers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _xDatePickers[key];
    }
  });
});
var _DateRangePickerDay = require("./DateRangePickerDay");
Object.keys(_DateRangePickerDay).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DateRangePickerDay[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DateRangePickerDay[key];
    }
  });
});
var _MultiInputDateRangeField = require("./MultiInputDateRangeField");
Object.keys(_MultiInputDateRangeField).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MultiInputDateRangeField[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MultiInputDateRangeField[key];
    }
  });
});
var _MultiInputTimeRangeField = require("./MultiInputTimeRangeField");
Object.keys(_MultiInputTimeRangeField).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MultiInputTimeRangeField[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MultiInputTimeRangeField[key];
    }
  });
});
var _MultiInputDateTimeRangeField = require("./MultiInputDateTimeRangeField");
Object.keys(_MultiInputDateTimeRangeField).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MultiInputDateTimeRangeField[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MultiInputDateTimeRangeField[key];
    }
  });
});
var _SingleInputDateRangeField = require("./SingleInputDateRangeField");
Object.keys(_SingleInputDateRangeField).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SingleInputDateRangeField[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SingleInputDateRangeField[key];
    }
  });
});
var _SingleInputTimeRangeField = require("./SingleInputTimeRangeField");
Object.keys(_SingleInputTimeRangeField).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SingleInputTimeRangeField[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SingleInputTimeRangeField[key];
    }
  });
});
var _SingleInputDateTimeRangeField = require("./SingleInputDateTimeRangeField");
Object.keys(_SingleInputDateTimeRangeField).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SingleInputDateTimeRangeField[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SingleInputDateTimeRangeField[key];
    }
  });
});
var _DateRangeCalendar = require("./DateRangeCalendar");
Object.keys(_DateRangeCalendar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DateRangeCalendar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DateRangeCalendar[key];
    }
  });
});
var _PickersRangeCalendarHeader = require("./PickersRangeCalendarHeader");
Object.keys(_PickersRangeCalendarHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _PickersRangeCalendarHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PickersRangeCalendarHeader[key];
    }
  });
});
var _DateRangePicker = require("./DateRangePicker");
Object.keys(_DateRangePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DateRangePicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DateRangePicker[key];
    }
  });
});
var _DesktopDateRangePicker = require("./DesktopDateRangePicker");
Object.keys(_DesktopDateRangePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DesktopDateRangePicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DesktopDateRangePicker[key];
    }
  });
});
var _MobileDateRangePicker = require("./MobileDateRangePicker");
Object.keys(_MobileDateRangePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MobileDateRangePicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MobileDateRangePicker[key];
    }
  });
});
var _StaticDateRangePicker = require("./StaticDateRangePicker");
Object.keys(_StaticDateRangePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _StaticDateRangePicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StaticDateRangePicker[key];
    }
  });
});
var _DateTimeRangePicker = require("./DateTimeRangePicker");
Object.keys(_DateTimeRangePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DateTimeRangePicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DateTimeRangePicker[key];
    }
  });
});
var _DesktopDateTimeRangePicker = require("./DesktopDateTimeRangePicker");
Object.keys(_DesktopDateTimeRangePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DesktopDateTimeRangePicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DesktopDateTimeRangePicker[key];
    }
  });
});
var _MobileDateTimeRangePicker = require("./MobileDateTimeRangePicker");
Object.keys(_MobileDateTimeRangePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MobileDateTimeRangePicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MobileDateTimeRangePicker[key];
    }
  });
});
var _dateRangeViewRenderers = require("./dateRangeViewRenderers");
Object.keys(_dateRangeViewRenderers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _dateRangeViewRenderers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dateRangeViewRenderers[key];
    }
  });
});
var _models = require("./models");
Object.keys(_models).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _models[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _models[key];
    }
  });
});
var _validation = require("./validation");
Object.keys(_validation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _validation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validation[key];
    }
  });
});
/**
 * @deprecated Use `@mui/x-license` package instead:
 * @example import { LicenseInfo } from '@mui/x-license';
 */
class LicenseInfo extends _xLicense.LicenseInfo {}

// Fields

// Calendars

// New pickers

// View renderers
exports.LicenseInfo = LicenseInfo;